export default __webpack_public_path__ + "static/media/rocket_anim_84.64aeb14b.png";